// extracted by css-extract-rspack-plugin
var _1 = "Em3jUDLAKXFQTa6LnkPr1g--";
export { _1 as "category" }
